import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./index.module.scss";
import AppCtrl from "../../../control/AppCtrl";
import Utils from "../../../utils/Utils";
import SyncDataID from "../../../utils/SyncDataID";
import LANGUAGE_TYPE from "../../../utils/Language";
import Config from "../../../utils/Config";
import EFunction from "../../../utils/FunctionPage";
import switchFunc from "../../../redux/switchFunc/switchFuncAction";
import useUserCoins from "../../../redux/userCoins/userCoinsAction";
import useAlert from "../../../hook/useAlert";

function SettingsPage(prop) {
  const changePassword = prop.changePassword ? true : false;
  const verifyPhone = prop.verifyPhone ? true : false;
  const normalMode = prop.normalMode ? true : false;
  const text = Config.text.settingsPage;
  const { setFunc } = switchFunc();
  const { userCoins } = useUserCoins();
  const { showAlert } = useAlert();

  const navigate = useNavigate();

  //===========================================================================
  const [smsProviderIndex, setSmsProviderIndex] = useState(0);

  useEffect(() => {
    componentDidMount();
    return componentWillUnmount;
  }, []);

  useEffect(() => {
    const userInfo = AppCtrl.userInfo();
    const uiUserNameInput = document.getElementById("userNameInput");
    if (uiUserNameInput)
      uiUserNameInput.value = userInfo.nickName() || AppCtrl.cacheAccount();
    const uiAccountInput = document.getElementById("userAccountInput");
    if (uiAccountInput)
      uiAccountInput.value = userInfo.Account || AppCtrl.cacheAccount();
    const uiOldPasswordInput = document.getElementById("userOldPasswordInput");
    if (uiOldPasswordInput) uiOldPasswordInput.value = AppCtrl.cachePassword();
    const uiUserPhoneInput = document.getElementById("userPhoneInput");
    if (uiUserPhoneInput && userInfo.PhoneNo)
      uiUserPhoneInput.value = userInfo.PhoneNo;
    const uiUserNewNickNameInput = document.getElementById(
      "userNewNickNameInput"
    );
    if (uiUserNewNickNameInput)
      uiUserNewNickNameInput.value = userInfo.NickName;
    const uiUserNewPhoneNoInput = document.getElementById(
      "userNewPhoneNoInput"
    );
    if (uiUserNewPhoneNoInput) uiUserNewPhoneNoInput.value = userInfo.PhoneNo;
  }, [userCoins]);
  //===========================================================================

  function PreLoad() {
    const uicountryCode_set_1 = document.getElementById("countryCode_set_1");
    if (uicountryCode_set_1) uicountryCode_set_1.value = Config.countryCode;
    const uicountryCode_set_2 = document.getElementById("countryCode_set_2");
    if (uicountryCode_set_2) uicountryCode_set_2.value = Config.countryCode;

    const uichangeUserInfoBlock = document.getElementById(
      "changeUserInfoBlock"
    );
    const changeUserInfo = Config.changeUserInfo
      ? Config.changeUserInfo
      : false;
    if (uichangeUserInfoBlock && !changeUserInfo) {
      uichangeUserInfoBlock.remove();
    }
  }

  function componentDidMount() {
    PreLoad();
  }

  function componentDidUpdate() {}

  function componentWillUnmount() {}

  function onLoginResponse(resObj) {
    try {
      const status = resObj.status;
      const language = AppCtrl.getLanguage();
      if (status == "success") {
        // replace password in cache
        const uiNewPasswordInput = document.getElementById(
          "userNewPasswordInput"
        );
        if (uiNewPasswordInput)
          AppCtrl.setCachePassword(uiNewPasswordInput.value);

        const { agent, token, appId, award } = resObj;
        if (token && token.length > 0) {
          let title = "";
          let awardMsg = "";
          switch (language) {
            case LANGUAGE_TYPE.zh_TW:
              title = "變更密碼成功。";
              if (award && award.value > 0)
                awardMsg = "獎勵贈分: " + award.value + "\r\n已經加入您帳號。";
              break;
            case LANGUAGE_TYPE.en_US:
            default:
              title = "Password changed";
              if (award && award.value > 0)
                awardMsg =
                  "Award: " + award.value + "\r\n send to your account";
              break;
          }
          showAlert({
            title: title,
            text: awardMsg,
            icon: "success",
            showConfirmButton: false,
            timer: 1350,
          });

          AppCtrl.getUserInfo(function (obj) {
            const strUserInfo = obj["UserInfo"].toString();
            const objUserInfo = JSON.parse(strUserInfo);
            //
            setTimeout(function () {
              // check if user isn't verified, switch to settingsPage
              const mainSettings = AppCtrl.mainSettings();
              const userInfo = AppCtrl.userInfo();
              // if user's phone not verified, route to settingsPage
              if (mainSettings.VerifyUserInfo && !userInfo.Verified) {
                setFunc(EFunction.verifyPhone);
                // navigate('/verify-phone');
                switch (language) {
                  case LANGUAGE_TYPE.zh_TW:
                    showAlert({ title: "驗證帳號能享受更多遊戲權利。" });
                    // AppCtrl.alert("驗證帳號能享受更多遊戲權利。");
                    break;
                  case LANGUAGE_TYPE.en_US:
                  default:
                    showAlert({
                      title: "Verify account to enjoy more benefit.",
                    });
                    // AppCtrl.alert("Verify account to enjoy more benefit.");
                    break;
                }
              } else {
                // show winLobbyPage for user to choose winLobbyManager
                setFunc(EFunction.winLobby);
                // navigate('/lobby');
              }
            }, 1000);
          });
        } else {
          switch (language) {
            case LANGUAGE_TYPE.zh_TW:
              throw new Error("請重新登入");
              break;
            case LANGUAGE_TYPE.en_US:
            default:
              throw new Error("Please Login again!");
              break;
          }
        }
      } else {
        throw new Error(resObj.error);
      }
    } catch (ex) {
      showAlert({ title: ex.message });
      // AppCtrl.alert(ex.message);
      setFunc(EFunction.login);
      // navigate('/login');
    }
  }

  function onUserChangePasswordOk() {
    const userAccount = AppCtrl.cacheAccount();
    const oldPassword = AppCtrl.cachePassword();
    const uiNewPasswordInput = document.getElementById("userNewPasswordInput");
    const uiConfirmPasswordInput = document.getElementById(
      "userConfirmPasswordInput"
    );
    const newPassword = uiNewPasswordInput ? uiNewPasswordInput.value : null;
    const confirmPassword = uiConfirmPasswordInput
      ? uiConfirmPasswordInput.value
      : null;

    const language = AppCtrl.getLanguage();

    if (newPassword == null || newPassword.length == 0) {
      switch (language) {
        case LANGUAGE_TYPE.zh_TW:
          showAlert({ title: "密碼不可為空值" });
          // AppCtrl.alert("密碼不可為空值");
          break;
        case LANGUAGE_TYPE.en_US:
        default:
          showAlert({ title: "Please input PW" });
          // AppCtrl.alert("Please input PW");
          break;
      }
    } else if (newPassword == oldPassword) {
      switch (language) {
        case LANGUAGE_TYPE.zh_TW:
          showAlert({ title: "新密碼與舊密碼不可相同" });
          // AppCtrl.alert("新密碼與舊密碼不可相同");
          break;
        case LANGUAGE_TYPE.en_US:
        default:
          showAlert({ title: "New PW and Old PW are the same!" });
          // AppCtrl.alert("New PW and Old PW are the same!");
          break;
      }
    } else if (newPassword != confirmPassword) {
      switch (language) {
        case LANGUAGE_TYPE.zh_TW:
          showAlert({ title: "兩次輸入的密碼不相同" });
          // AppCtrl.alert("兩次輸入的密碼不相同");
          break;
        case LANGUAGE_TYPE.en_US:
        default:
          showAlert({ title: "Tow New PW field must be same!" });
          // AppCtrl.alert("Tow New PW field must be same!");
          break;
      }
    } else {
      const uiBtnUserChangePasswordOk = document.getElementById(
        "btnUserChangePasswordOk"
      );
      const uiBtnSettingsPageBack = document.getElementById(
        "btnSettingsPageBack"
      );
      if (uiBtnUserChangePasswordOk) uiBtnUserChangePasswordOk.disabled = true;
      if (uiBtnSettingsPageBack) uiBtnSettingsPageBack.disabled = true;
      // proceed changing password
      AppCtrl.changeUserPassword(userAccount, oldPassword, newPassword);
      // delay and do login again
      setTimeout(function () {
        if (uiBtnUserChangePasswordOk)
          uiBtnUserChangePasswordOk.disabled = false;
        if (uiBtnSettingsPageBack) uiBtnSettingsPageBack.disabled = false;
        AppCtrl.requestLoginToken(
          userAccount,
          newPassword,
          true,
          onLoginResponse
        );
      }, 2000);
    }
  }

  function onUserChangeUserInfoOk() {
    try {
      let newNickName = null;
      let newPhoneNo = null;
      const uiUserNewNickNameInput = document.getElementById(
        "userNewNickNameInput"
      );
      if (uiUserNewNickNameInput) newNickName = uiUserNewNickNameInput.value;
      const uiUserNewPhoneNoInput = document.getElementById(
        "userNewPhoneNoInput"
      );
      if (uiUserNewPhoneNoInput) newPhoneNo = uiUserNewPhoneNoInput.value;

      if (!newNickName)
        throw new Error(AppCtrl.textConverter().convert("請輸入暱稱"));
      if (!newPhoneNo)
        throw new Error(AppCtrl.textConverter().convert("請輸入電話"));
      AppCtrl.changeUserInfo({
        NickName: newNickName,
        //PhoneNo: newPhoneNo
      });
    } catch (ex) {
      showAlert({ title: ex.message });
      // AppCtrl.alert(ex.message);
    }
  }

  function onUserSetVerifyPhone() {
    const userInfo = AppCtrl.userInfo();
    const language = AppCtrl.getLanguage();
    try {
      const uiUserSetVerifyPhone = document.getElementById(
        "btnUserSetVerifyPhone"
      );
      if (uiUserSetVerifyPhone) uiUserSetVerifyPhone.disabled = true;

      const uiUserSetVerifyPhoneInput = document.getElementById(
        "userSetVerifyPhoneInput"
      );
      if (!uiUserSetVerifyPhoneInput)
        throw new Error("no userSetVerifyPhoneInput element");
      const phoneNumber = parseInt(uiUserSetVerifyPhoneInput.value);

      if (phoneNumber < Config.minPhoneNO || phoneNumber > Config.maxPhoneNo) {
        if (language == LANGUAGE_TYPE.zh_TW) throw new Error("無效的電話號碼");
        else throw new Error("Invalid phone number!");
      }

      const apiUrl = "APIs/SendVerifySMS.ashx";
      //const phoneNo = Config.countryCode +  uiUserSetVerifyPhoneInput.value;
      const countrycode = Config.countryCode;
      const phoneNo = uiUserSetVerifyPhoneInput.value;
      const apiData = {
        account: userInfo.Account,
        countryCode: countrycode,
        phoneNo: phoneNo,
        providerIndex: smsProviderIndex, //smsProvider: Config.smsProvider//
      };
      Utils.postAPI(apiUrl, apiData, "x-www-form-urlencoded")
        .then(function (response) {
          const result = response.ResultCode;
          if (result !== "OK") {
            let errMsg;
            switch (result) {
              case "E0003":
                switch (language) {
                  case LANGUAGE_TYPE.zh_TW:
                    errMsg = `帳號無效或電話號碼${uiUserSetVerifyPhoneInput.value}已被其他帳號驗證.`;
                    break;
                  case LANGUAGE_TYPE.en_US:
                  default:
                    errMsg = `invalid user or phone number ${uiUserSetVerifyPhoneInput.value} had been used.`;
                    break;
                }
                break;
              case "E0004":
                switch (language) {
                  case LANGUAGE_TYPE.zh_TW:
                    errMsg = "發送簡訊失敗。\n請聯絡管理員進行人工驗證";
                    break;
                  case LANGUAGE_TYPE.en_US:
                  default:
                    errMsg = "failed to sned SMS.\nPlease ask manual verifying";
                    break;
                }
                break;
              case "E0005":
                switch (language) {
                  case LANGUAGE_TYPE.zh_TW:
                    errMsg = "已超出單日可驗證次數。";
                    break;
                  case LANGUAGE_TYPE.en_US:
                  default:
                    errMsg = "Over one day verifying count.";
                    break;
                }
                break;
              default: {
                errMsg = response.ResultObject.toString();
                break;
              }
            }
            throw new Error(errMsg);
          } else {
            // disable send sms btn for a while
            setTimeout(function () {
              uiUserSetVerifyPhone.disabled = false;
            }, 20000);
            // popup message
            switch (language) {
              case LANGUAGE_TYPE.zh_TW:
                showAlert({ title: "系統已發送驗證碼，請稍候。" });
                // AppCtrl.alert('系統已發送驗證碼，請稍候。');
                break;
              case LANGUAGE_TYPE.en_US:
              default:
                showAlert({ title: "Please wait for the verifying code!" });
                // AppCtrl.alert('Please wait for the verifying code!');
                break;
            }
          }
          // increase smsProviderIndex to try next sms
          setSmsProviderIndex(smsProviderIndex + 1);
        })
        .catch(function (err) {
          if (uiUserSetVerifyPhone) uiUserSetVerifyPhone.disabled = false;
          // popup err alert
          const errMsg = err.message;
          switch (language) {
            case Language_TW:
              showAlert({ title: "驗證電話錯誤", text: errMsg });
              // AppCtrl.alert('驗證電話錯誤', errMsg);
              break;
            case LANGUAGE_TYPE.en_US:
            default:
              showAlert({
                title: "failed to verify phone number",
                text: errMsg,
              });
              // AppCtrl.alert('failed to verify phone number', errMsg);
              break;
          }
        });
    } catch (ex) {
      showAlert({ title: ex.message });
      // AppCtrl.alert(ex.message);
    }
  }

  function onUserSetVerifyCode() {
    const userInfo = AppCtrl.userInfo();
    const language = AppCtrl.getLanguage();
    try {
      const uiUserSetVerifyCodeInput = document.getElementById(
        "userSetVerifyCodeInput"
      );
      if (!uiUserSetVerifyCodeInput)
        throw new Error("no userSetVerifyCodeInput element");
      const code = parseInt(uiUserSetVerifyCodeInput.value);
      if (code < 0 || code > 999999) {
        switch (language) {
          case LANGUAGE_TYPE.zh_TW:
            throw new Error("無效的驗證碼");
            break;
          case LANGUAGE_TYPE.en_US:
          default:
            throw new Error("Invalid verify code!");
            break;
        }
      }

      const apiUrl = "APIs/SendVerifyCode.ashx";
      const apiData = {
        account: userInfo.Account,
        code: uiUserSetVerifyCodeInput.value,
      };
      Utils.postAPI(apiUrl, apiData, "x-www-form-urlencoded")
        .then(function (response) {
          const result = response.ResultCode;
          if (result !== "OK") {
            let errMsg;
            switch (result) {
              case "E0003":
                switch (language) {
                  case LANGUAGE_TYPE.zh_TW:
                    errMsg = "驗證失敗";
                    break;
                  case LANGUAGE_TYPE.en_US:
                  default:
                    errMsg = "verifying failed.";
                    break;
                }
                break;
              default: {
                errMsg = response.ResultObject.toString();
                break;
              }
            }
            throw new Error(errMsg);
          } else {
            AppCtrl.requestSync(SyncDataID.SyncUserInfo, userInfo.Account);
            switch (language) {
              case LANGUAGE_TYPE.zh_TW:
                showAlert({ title: "驗證完成" });
                // AppCtrl.alert('驗證完成');
                break;
              case LANGUAGE_TYPE.en_US:
              default:
                showAlert({ title: "Verify done!" });
                // AppCtrl.alert('Verify done!');
                break;
            }
            onBack();
          }
        })
        .catch(function (err) {
          const errMsg = err.message;
          switch (language) {
            case LANGUAGE_TYPE.zh_TW:
              showAlert({ title: `錯誤:${errMsg}` });
              // AppCtrl.alert(`錯誤:${errMsg}`);
              break;
            case LANGUAGE_TYPE.en_US:
            default:
              showAlert({ title: `Error:${errMsg}` });
              // AppCtrl.alert(`Error:${errMsg}`);
              break;
          }
        });
    } catch (ex) {
      showAlert({ title: ex.message });
      // AppCtrl.alert(ex.message);
    }
  }

  function onBack() {
    //AppCtrl.askMachineTokenInLobby();
    setFunc(EFunction.winLobby);
    // navigate('/lobby');
  }

  return (
    <div id="settingsPage" className={styles.settingsPage}>
      <div className={styles.mainArea}>
        {verifyPhone || normalMode ? (
          <div>
            <h3 id="settings">{`${text.settings}`}</h3>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                textAlign: "left",
                fontSize: "18px",
                width: "100%",
                height: "170px",
                color: "white",
              }}
            >
              <div
                style={{ margin: "0px 10px", width: "60%", textAlign: "left" }}
              >
                <div>
                  <span
                    style={{
                      textAlign: "left",
                      fontSize: "14px",
                      color: "white",
                    }}
                  >{`${text.user}:`}</span>
                  <input
                    id="userNameInput"
                    type="text"
                    style={{
                      width: "60%",
                      margin: "10px 5px",
                      fontSize: "14px",
                      textAlign: "center",
                      color: "black",
                    }}
                    disabled
                  />
                </div>
                <div>
                  <span
                    style={{
                      textAlign: "left",
                      fontSize: "14px",
                      color: "white",
                    }}
                  >{`${text.account}:`}</span>
                  <input
                    id="userAccountInput"
                    type="text"
                    style={{
                      width: "60%",
                      margin: "10px 5px",
                      fontSize: "14px",
                      textAlign: "center",
                      color: "black",
                    }}
                    disabled
                  />
                </div>
                <div>
                  <span
                    style={{
                      textAlign: "left",
                      fontSize: "14px",
                      color: "white",
                    }}
                  >{`${text.pwd}:`}</span>
                  <input
                    id="userOldPasswordInput"
                    type="password"
                    style={{
                      width: "60%",
                      margin: "10px 5px",
                      fontSize: "14px",
                      textAlign: "center",
                      color: "black",
                    }}
                    disabled
                  />
                </div>
                <div>
                  <span
                    style={{
                      textAlign: "left",
                      fontSize: "14px",
                      color: "white",
                    }}
                  >{`${text.phone}:`}</span>
                  <input
                    id="countryCode_set_1"
                    type="text"
                    style={{
                      width: "10%",
                      fontSize: "14px",
                      textAlign: "center",
                      color: "black",
                    }}
                    disabled
                  />
                  <input
                    id="userPhoneInput"
                    style={{
                      width: "50%",
                      margin: "5px 0px",
                      fontSize: "14px",
                      textAlign: "center",
                      color: "black",
                    }}
                    disabled
                  />
                </div>
              </div>
              <div
                style={{ margin: "0px 10px", width: "40%", textAlign: "right" }}
              >
                <button
                  id="btnSettingsPageBack"
                  className="large red button"
                  style={{
                    margin: "5px auto",
                    width: "100%",
                    height: "50px",
                    maxWidth: "160px",
                    fontSize: "16px",
                  }}
                  onClick={onBack}
                >{`${text.back}`}</button>
              </div>
            </div>
            <hr></hr>
          </div>
        ) : null}
        {verifyPhone || normalMode ? (
          <div style={{ margin: "0px 10px" }}>
            <h3 id="verifyPhone">{`${text.verifyPhone}`}</h3>
            <div style={{ padding: "5px 10px", textAlign: "center" }}>
              <div
                id="userVerifyPhoneHint"
                style={{
                  padding: "10px",
                  textAlign: "left",
                  fontSize: "14px",
                  width: "100%",
                  color: "white",
                  borderRadius: "10px",
                  backgroundColor: "rgba(0, 0, 0, 0.3)",
                }}
              >
                <span>{`${text.verifyPhoneHint}`}</span>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  margin: "10 auto",
                  height: "40px",
                }}
              >
                <div style={{ width: "60%" }}>
                  <input
                    id="countryCode_set_2"
                    type="text"
                    style={{
                      width: "10%",
                      fontSize: "18px",
                      textAlign: "center",
                      color: "black",
                    }}
                    disabled
                  />
                  <input
                    id="userSetVerifyPhoneInput"
                    style={{
                      width: "70%",
                      margin: "5px 0px",
                      fontSize: "18px",
                      textAlign: "center",
                      color: "black",
                    }}
                    placeholder={`${text.phonePlaceHolder}`}
                  />
                </div>
                <div style={{ width: "40%" }}>
                  <button
                    id="btnUserSetVerifyPhone"
                    className="blue button"
                    style={{
                      width: "80%",
                      maxWidth: "160px",
                      fontSize: "18px",
                    }}
                    onClick={onUserSetVerifyPhone}
                  >{`${text.sendSMS}`}</button>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  margin: "10 auto",
                  height: "40px",
                }}
              >
                <div style={{ width: "60%" }}>
                  <input
                    id="userSetVerifyCodeInput"
                    style={{
                      margin: "5px 0px",
                      width: "90%",
                      fontSize: "18px",
                      textAlign: "center",
                      color: "black",
                    }}
                    placeholder={`${text.codePlaceHolder}`}
                  />
                </div>
                <div style={{ width: "40%" }}>
                  <button
                    className="blue button"
                    style={{
                      width: "80%",
                      maxWidth: "160px",
                      fontSize: "18px",
                    }}
                    onClick={onUserSetVerifyCode}
                  >{`${text.verify}`}</button>
                </div>
              </div>
            </div>
            <hr></hr>
          </div>
        ) : null}
        {changePassword || normalMode ? (
          <div>
            <h3 id="changePassword">{`${text.changePassword}`}</h3>
            <div
              style={{
                margin: "10px auto",
                maxWidth: "320px",
                textAlign: "center",
              }}
            >
              <div
                style={{ textAlign: "left", fontSize: "14px", color: "white" }}
              >{`${text.newPwd}:`}</div>
              <div style={{ margin: "10 auto", height: "40px" }}>
                <input
                  id="userNewPasswordInput"
                  type="password"
                  style={{
                    width: "80%",
                    fontSize: "18px",
                    textAlign: "center",
                    color: "black",
                  }}
                  placeholder={`${text.newPwdPlaceHolder}`}
                />
              </div>
              <div
                style={{ textAlign: "left", fontSize: "14px", color: "white" }}
              >{`${text.confirmPwd}:`}</div>
              <div style={{ margin: "10 auto", height: "40px" }}>
                <input
                  id="userConfirmPasswordInput"
                  type="password"
                  style={{
                    width: "80%",
                    fontSize: "18px",
                    textAlign: "center",
                    color: "black",
                  }}
                  placeholder={`${text.confirmPwdPlaceHolder}`}
                />
              </div>
              <div style={{ padding: "10px", height: "40px" }}>
                <button
                  id="btnUserChangePasswordOk"
                  className="large blue button"
                  style={{ width: "48%", fontSize: "18px" }}
                  onClick={onUserChangePasswordOk}
                >{`${text.confirm}`}</button>
              </div>
            </div>
            <hr></hr>
          </div>
        ) : null}
        {normalMode ? (
          <div id="changeUserInfoBlock">
            <h3 id="changeUserInfo">{`${text.changeUserInfo}`}</h3>
            <div
              style={{
                margin: "10px auto",
                maxWidth: "320px",
                textAlign: "center",
              }}
            >
              <div
                style={{ textAlign: "left", fontSize: "14px", color: "white" }}
              >{`${text.newNickName}:`}</div>
              <div style={{ margin: "10 auto", height: "40px" }}>
                <input
                  id="userNewNickNameInput"
                  style={{
                    width: "80%",
                    fontSize: "18px",
                    textAlign: "center",
                    color: "black",
                  }}
                  placeholder={`${text.newNickNamePlaceHolder}`}
                />
              </div>
              <div
                style={{
                  textAlign: "left",
                  fontSize: "14px",
                  color: "white",
                  display: "none",
                }}
              >{`${text.newPhoneNo}:`}</div>
              <div
                style={{ margin: "10 auto", height: "40px", display: "none" }}
              >
                <input
                  id="userNewPhoneNoInput"
                  style={{
                    width: "80%",
                    fontSize: "18px",
                    textAlign: "center",
                    color: "black",
                  }}
                  placeholder={`${text.newPhoneNoPlaceHolder}`}
                />
              </div>
              <div style={{ padding: "10px", height: "40px" }}>
                <button
                  className="large blue button"
                  style={{ width: "48%", fontSize: "18px" }}
                  onClick={onUserChangeUserInfoOk}
                >{`${text.confirm}`}</button>
              </div>
            </div>
            <hr></hr>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default SettingsPage;
